import styled from "styled-components";

export const NotificationsCounterStyles = styled.div`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: ${({ theme }) => theme.radius.rounded};
  background: ${({ theme }) => theme.colors.error[500]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 1;
`;
